import gql from 'graphql-tag'

export const teamOrdersQuery = gql`
    query TeamOrders(
        $teamId: Int!
        $userId: Int
        $filters: TeamQuoteAndOrderFilterInput
        $limit: Int
        $offset: Int
        $sort: TeamQuotesAndOrdersSortInput
    ) {
        teamOrders(
            teamId: $teamId
            userId: $userId
            filters: $filters
            limit: $limit
            offset: $offset
            sort: $sort
        ) {
            totalCount
            items {
                ... on SalesOrder {
                    id
                    name
                    deliveryStatus
                    orderDate
                    createdAt
                    fictivEstimatedDeliveryDate
                    paymentDetails {
                        paidBy {
                            id
                            email
                        }
                        paymentType
                        purchaseOrderNumber
                    }
                    totalAmount
                    salesOrderLines(limit: 4) {
                        totalCount
                        items {
                            id
                            revision {
                                thumbnailUri
                            }
                        }
                    }
                    shipments {
                        items {
                            trackingData {
                                estDeliveryDate
                                trackingDetails {
                                    status
                                    datetime
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`
